import { SET_BASE_PAYMENT_METHODS } from "./type";

export const setBasePaymentMethods = (paymentMethods) => {
  return {
    type: SET_BASE_PAYMENT_METHODS,
    paymentMethods: paymentMethods,
  };
};
